import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useTenantAuth } from '../context/TenantAuthContext';

export default function TenantKnowledgeBaseLayout() {
  const { ready, hasPermission } = useTenantAuth();

  if (!ready) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!hasPermission('tenant.kb.view')) {
    return <Navigate to="/tenant" replace />;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Knowledge base
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Help articles for your organization. Slugs must be unique within your tenant.
      </Typography>
      <Outlet />
    </Box>
  );
}
